import { useEffect, useRef } from 'react'
import { useAuth } from 'torqcloud-ui'

/**
 * Identifies the logged-in user to the Crisp chat widget so support conversations
 * show the user's email/name
 */
export const useCrispIdentity = () => {
  const { isAuthenticated, user } = useAuth()
  const email = user?.email
  const name = user?.name
  const wasIdentified = useRef(false)

  useEffect(() => {
    if (!window.$crisp) return

    if (isAuthenticated && email) {
      window.$crisp.push(['set', 'user:email', [email]])
      if (name) {
        window.$crisp.push(['set', 'user:nickname', [name]])
      }
      wasIdentified.current = true
    } else if (!isAuthenticated && wasIdentified.current) {
      window.$crisp.push(['do', 'session:reset'])
      wasIdentified.current = false
    }
  }, [isAuthenticated, email, name])
}
